import {
	GET_MINORS_REQUEST,
	GET_MINORS_SUCCESS,
	GET_MINORS_ERROR,
	GET_MINOR_REQUEST,
	GET_MINOR_SUCCESS,
	GET_MINOR_ERROR,
	CREATE_MINOR_REQUEST,
	CREATE_MINOR_SUCCESS,
	CREATE_MINOR_ERROR,
	EDIT_MINOR_REQUEST,
	EDIT_MINOR_SUCCESS,
	EDIT_MINOR_ERROR,
	DELETE_MINOR_REQUEST,
	DELETE_MINOR_SUCCESS,
	DELETE_MINOR_ERROR
} from "@/actions"

import {
	minorService
} from "@/services"

import { isEmpty, addNewFilter, decodeLaravelValidationErrors } from "@/utilities"

const state = {
	minors: [],
	minor: {},
	loading: false,
	loadedOnce: true
}

const getters = {
	minors: state => state.minors,
	minor: state => state.minor,
	minorsLoadedOnce: state => state.loadedOnce,
	minorsSorted: state => state.minors.sort((a, b) => a.label.localeCompare(b.label)),
	minorSelectOptions: state => state.minors.filter(m => m.deleted_at === null).map(minor => ({ value: minor.uuid, label: minor.label })),
	minorOptionFilterUuid: (state) => uuid => state.minors.find(m => m?.uuid == uuid)
}

const actions = {
	async getMinors({ commit }) {
		commit("GET_MINORS_REQUEST")
		const response = await minorService.getMinors();
		const { status, data } = response
		switch (status) {
			case 200:
				data.success ? commit("GET_MINORS_SUCCESS", data) : null
				break
			default:
				commit("GET_MINORS_ERROR")
		}
		return response
	},
	async getMinor({ commit }, params) {
		commit("GET_MINOR_REQUEST")
		const response = await minorService.getMinor(params)
		const { status, data } = response
		switch (status) {
			case 200:
				data.success ? commit("GET_MINOR_SUCCESS", data) : null
				break
			default:
				commit("GET_MINOR_ERROR")
				break
		}
		return response
	},
	async createMinor({ commit, dispatch }, params) {
		commit("CREATE_MINOR_REQUEST")
		const response = await minorService.createMinor(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("CREATE_MINOR_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Minor created successfully", { root: true });
				}

				if (data.error) {
					commit("DELETE_MINOR_ERROR")
					dispatch("alert/createAlertErrors", decodeLaravelValidationErrors(data.errors) ?? "Something went wrong. Could not create minor.", { root: true });
				}

				break
			default:
				commit("CREATE_MINOR_ERROR")
		}
		return response
	},
	async editMinor({ commit, dispatch }, params) {
		commit("EDIT_MINOR_REQUEST")
		const response = await minorService.editMinor(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("EDIT_MINOR_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Minor updated successfully", { root: true });
				}

				if (data.error) {
					commit("DELETE_MINOR_ERROR")
					dispatch("alert/createAlertErrors", decodeLaravelValidationErrors(data.errors) ?? "Something went wrong. Could not update minor.", { root: true });
				}

				break
			default:
				commit("EDIT_MINOR_ERROR")
		}
		return response
	},
	async deleteMinor({ commit, dispatch }, uuid) {
		commit("DELETE_MINOR_REQUEST")
		const response = await minorService.deleteMinor(uuid)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					const { minor } = data;
					commit("DELETE_MINOR_SUCCESS", { ...minor, uuid });
					dispatch("alert/createAlertSuccess", "Minor deleted successfully", { root: true });
				}

				if (data.error) {
					commit("DELETE_MINOR_ERROR")
					dispatch("alert/createAlertErrors", decodeLaravelValidationErrors(data.errors) ?? "Something went wrong. Could not delete minor.", { root: true });
				}

				break
			default:
				commit("DELETE_MINOR_ERROR")
		}
		return response
	}
}

const mutations = {
	[GET_MINORS_REQUEST]: state => {
		state.loading = true
	},
	[GET_MINORS_SUCCESS]: (state, data) => {
		const minors = data.minors
		state.minors = addNewFilter(state.minors, minors);
		state.loading = false
		state.loadedOnce = true
	},
	[GET_MINORS_ERROR]: state => {
		state.loading = false
		state.error = true
		state.loadedOnce = true
	},
	[GET_MINOR_REQUEST]: state => {
		state.loading = true
	},
	[GET_MINOR_SUCCESS]: (state, data) => {
		const { minor } = data
		state.minors = addNewFilter(state.minors, [minor])
		state.loading = false
	},
	[GET_MINOR_ERROR]: (state, data) => {
		state.loading = false
	},

	[CREATE_MINOR_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_MINOR_SUCCESS]: (state, data) => {
		const { minor } = data
		state.minors = addNewFilter(state.minors, [minor])
		state.loading = false
	},
	[CREATE_MINOR_ERROR]: state => {
		state.loading = false
	},

	[EDIT_MINOR_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_MINOR_SUCCESS]: (state, data) => {
		const { minor } = data
		state.minors = addNewFilter(state.minors, [minor])
		state.loading = false
	},
	[EDIT_MINOR_ERROR]: state => {
		state.loading = false
	},

	[DELETE_MINOR_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_MINOR_SUCCESS]: (state, minor) => {

		const { uuid, deleted_at } = minor;
		
		if (!isEmpty(deleted_at)) {
			state.minors = addNewFilter(state.minors, [minor]);
		} else {
			state.minors = state.minors.filter(m => m.uuid != uuid)
		}

		state.loading = false
	},
	[DELETE_MINOR_ERROR]: (state) => {
		state.loading = false
	}

}

export const minor = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
